import React from "react";

import Header from "./components/Header";
import Main from "./pages/Main";
import Footer from "./components/Footer";

import './assets/css/app.css';


function App() {
  return (
    <div className="App">
      
      <Header />

      <Main />

      <Footer />
      
    </div>
  ) ;
}

export default App;
